import React, { useEffect, useState } from "react";
import API from "../utils/axiosInstance";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import "./Transactions.css";

const AdminSchedulePage = () => {
  const [schedules, setSchedules] = useState([]);

  useEffect(() => {
    const fetchSchedules = async () => {
      try {
        const { data } = await API.get("/schedules/all"); // Adjust route if needed
        setSchedules(data);
        console.log("Schedule Data:", data);

      } catch (err) {
        console.error("Failed to fetch full schedule", err.response?.data || err.message);
      }
    };

    fetchSchedules();
  }, []);

  return (
   <div className="dashboard-wrapper">
  <div className="sidebar-fixed">
    <Sidebar isOpen={true} />
  </div>

  <div className="dashboard-main">
    <Navbar />

    <div className="transaction-content">
      <div className="table-container">
        <div className="table-header">
          <h4 className="section-title">📅 Full Class Schedule</h4>
        </div>

        {schedules.length === 0 ? (
          <p>No schedules available</p>
        ) : (
          <div className="table-scroll-wrapper">
            <table className="transactions-table">
              <thead>
                <tr>
                  <th>Course</th>
                  <th>Class Title</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Users</th>
                  <th>Join Link</th>
                  <th>Start URL (Admin)</th>
                </tr>
              </thead>
              <tbody>
                {schedules.map((s, index) => (
                  <tr key={index}>
                    <td>{s.course?.title || "N/A"}</td>
                    <td>{s.title}</td>
                    <td>{new Date(s.date).toDateString()}</td>
                    <td>{s.time}</td>
                    <td>
                      {s.users?.length > 0
                        ? s.users.map(u => u ? (
                            <div key={u.id}>{u.name} ({u.email})</div>
                          ) : null)
                        : "N/A"}
                    </td>
                    <td>
                      <a href={s.joinLink} target="_blank" rel="noopener noreferrer">
                        Join Link
                      </a>
                    </td>
                    <td>
                      <a href={s.startUrl} target="_blank" rel="noopener noreferrer">
                        Start Meeting
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  </div>
</div>

  );
};

export default AdminSchedulePage;
